import Modal from "./Modal";
import { buildOfferTitle } from "../utils/monthlyUpsell";

const MonthlyUpsellModal = ({
	isOpen,
	onClose,
	config,
	suggestedMonthlyAmount,
	singleAmount,
	onSwitchToMonthly,
	onContinueOneOff,
}) => {
	if (!config?.enabled) return null;

	const offerTitle = buildOfferTitle(suggestedMonthlyAmount);

	return (
		<Modal isOpen={isOpen} onClose={onClose} allowClose={true}>
			<div className="monthly-upsell-modal">
				<h2 className="monthly-upsell-modal__heading">{config.heading}</h2>
				{config.body && (
					<p className="monthly-upsell-modal__intro">{config.body}</p>
				)}

				<div className="monthly-upsell-modal__offer">
					<div className="monthly-upsell-modal__offer-content">
						{config.pound_icon_url && (
							<div className="monthly-upsell-modal__offer-icon" aria-hidden="true">
								<svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M0.0194022 13.7855V11.6027H1.25146V7.77072H0.135817V5.97598H1.25146V4.73422C1.25146 3.18202 1.73653 1.98876 2.70665 1.20296C3.68648 0.407454 5.03496 0 6.69388 0C8.35279 0 7.31476 2.94903e-07 7.71251 0.0291041C8.11026 0.0485066 8.51771 0.0776107 8.90576 0.106715C9.2065 0.135818 9.43933 0.155221 9.63336 0.174623V2.47382C9.40053 2.45442 9.1677 2.43502 8.92517 2.41562C8.54682 2.38651 8.12966 2.35741 7.6834 2.33801C7.20804 2.3186 6.9073 2.3089 6.68417 2.3089C6.01479 2.3089 5.49092 2.40591 5.07376 2.59994C4.64691 2.81337 4.34617 3.11411 4.17155 3.52156C4.00662 3.89991 3.91931 4.35587 3.91931 4.87974V5.98568H8.35279V7.78042H3.91931V11.6124H10.4095C10.0699 12.8639 8.91547 13.7952 7.55729 13.7952H0L0.0194022 13.7855Z" fill="currentColor"/>
								</svg>
							</div>
						)}
						<p className="monthly-upsell-modal__offer-title">{offerTitle}</p>
					</div>
					{config.offer_body && (
						<p className="monthly-upsell-modal__offer-body">
							{config.offer_body}
						</p>
					)}
				</div>

				<div className="monthly-upsell-modal__actions">
					<button
						type="button"
						className="monthly-upsell-modal__cta btn btn--solid btn--lime"
						onClick={onSwitchToMonthly}
					>
						<span>{config.cta_label || "Switch to monthly"}</span>
						<span className="monthly-heart" aria-hidden="true" />
					</button>

					<button
						type="button"
						className="monthly-upsell-modal__decline"
						onClick={onContinueOneOff}
					>
						{config.decline_label || "Continue with a one-off donation"}
					</button>
				</div>

				{singleAmount != null && (
					<p className="monthly-upsell-modal__sr-only">
						Based on your selected one-off gift of £
						{Number(singleAmount).toLocaleString("en-GB")}
					</p>
				)}
			</div>
		</Modal>
	);
};

export default MonthlyUpsellModal;
